const PAYMENT_API_BASE = process.env.REACT_APP_API_URL;

export const requestPaymentApi = async (path, options = {}) => {
  const response = await fetch(`${PAYMENT_API_BASE}${path}`, options);
  let data = {};

  try {
    data = await response.json();
  } catch {
    data = {};
  }

  return { response, data };
};
